import React, { Component } from 'react';
import Item from './Item';
import '../../assets/styles/MainMenu/index.sass';

class MainMenu extends Component {
  render() {
    return(
      <section className="MainMenu panel">
        <h1 className="panel__title">Conversions</h1>

        <nav>
          <ul className="MainMenu__list">
            <Item conversion="Mechanics"/>
            <Item conversion="Thermodynamics"/>
            <Item conversion="Electricity"/>
            <Item conversion="Magnetism"/>
            <Item conversion="Optics"/>
            <Item conversion="More..."/>
          </ul>
        </nav>
      </section>
    );
  }
}

export default MainMenu;
